import type { CompareQuoteFormInput } from './compare.types';
import type { QuoteDraftSelectorState } from '../../../global-store/quote-draft';

export function compareQuoteFormSelector(store: QuoteDraftSelectorState): CompareQuoteFormInput {
  const selectedPackage = store.selectedPackage();
  return { selectedPackage };
}
